<template>
  <div id="timon" v-if="$route.meta.extra">
    <div class="columns is-vcentered is-mobile helvetica">
      <div class="column is-3-desktop is-0-tablet is-0-mobile">
        <img src="~@/assets/icons/grupo.svg" alt="" />
      </div>
      <div class="column is-vcentered is-9-desktop is-11-mobile">
        <h1 class="title">
          <p>{{ cardTextLines($route.meta.extra.wheel.text)[0] }}</p>
          <p>{{ cardTextLines($route.meta.extra.wheel.text)[1] }}</p>
          <p>{{ cardTextLines($route.meta.extra.wheel.text)[2] }}</p>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    cardTextLines(textKey) {
      const splittedTranslation = this.$t(textKey).split('#')
      let translationParts = ['', '', '']
      splittedTranslation.forEach((element, index) => {
        translationParts[index] = element
      })

      return translationParts
    }
  }
}
</script>

<style lang="scss" scoped>
#timon {
  position: absolute;
  bottom: 100px;
  display: flex;
  left: 10px;
  width: 25%;
  max-width: 350px;
  height: 150px;
  border: solid 2px white;
  border-radius: 40px 80px 0 40px;
  box-shadow: 0 0 10px -5px;
  background-color: var(--rosa-dark-eco);

  .columns {
    height: 100%;
    width: 100%;
    margin: 0;
  }
  .column.is-3-desktop {
    border: solid var(--rosa-dark-eco);
    border-radius: 30px;
    padding: 0;
    margin-left: -3px;
    height: calc(100% + 4px);
    display: flex;
    background: white;

    img {
      margin: auto;
      max-width: 80%;
    }
  }

  h1 {
    line-height: 1em;
    color: white;
    margin: auto;
    text-align: center;
  }
}

@media (max-width: 1024px) {
  #timon {
    position: relative;
    top: 0;
    left: 0;
    max-width: unset;
    width: 100%;
    height: 65px;
    border-radius: 0;
    border: none;
    z-index: 99;
    
    h1 {
      font-size: 20px;
      display: flex;
      
      p {
        margin-right: .25em;
      }
    }
  }
}
</style>
